import { CameraHealthStatus } from '../interfaces/IVideo';

export const HEALTH_STATUS_COLORS: Record<CameraHealthStatus, string> = {
  healthy: '#2e7d32',
  unknown: '#9e9e9e',
  unreachable: '#d32f2f',
};

export const statusColor = (
  status: CameraHealthStatus | undefined
): string | null => {
  if (!status) return null;
  return HEALTH_STATUS_COLORS[status] ?? null;
};
